import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25837af4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"box\" data-v-25837af4><span style=\"--i:0;\" data-v-25837af4></span><span style=\"--i:1;\" data-v-25837af4></span><span style=\"--i:2;\" data-v-25837af4></span><span style=\"--i:3;\" data-v-25837af4></span><span style=\"--i:4;\" data-v-25837af4></span><span style=\"--i:5;\" data-v-25837af4></span><span style=\"--i:6;\" data-v-25837af4></span><span style=\"--i:7;\" data-v-25837af4></span></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}